(function(){
    'use strict'; 
    angular.module('app').controller('AccountingCustomersBillingSettingsController', AccountingCustomersBillingSettingsController); 
    AccountingCustomersBillingSettingsController.$inject = [
        'AccountingCustomersBillingSettingsTable'
    ]; 

    function AccountingCustomersBillingSettingsController(
        AccountingCustomersBillingSettingsTable
    ){
        const vm = this;

        init();
        function init(){
            vm.customersBillingSettigsTableData = new AccountingCustomersBillingSettingsTable().tableData; 
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingCustomersBillingSettingsController.js